<template>
  <div>
    <div v-if="fields" class="double-row">
      <Multiselect label="Field" :options="fields" :value="value && value.field" @input="onInput($event, 'field')" />
      <TextField label="Value" :value="value && value.value" @input="onInput($event, 'value')" />
    </div>
    <TextField v-else label="Value" :value="value && value.value" @input="onInput($event, 'value')" />
  </div>
</template>
<script>
import Multiselect from '@/components/common/Multiselect.vue';
import TextField from '@/components/common/TextField.vue';

export default {
  components: {
    Multiselect,
    TextField
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    fields() {
      return this.settings.fields ? Object.keys(this.settings.fields) : null;
    }
  },
  methods: {
    onInput(value, key) {
      this.$emit('input', { ...this.value, [key]: value });
    }
  }
};
</script>
<style lang="scss" scoped>
.double-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
</style>
